import { $, $$ } from '../utils/query-selector.js'
import parseSrcset from 'parse-srcset'

const photoswipeHtml = `
<!-- Root element of PhotoSwipe. Must have class pswp. -->
<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">

    <!-- Background of PhotoSwipe. It's a separate element as animating opacity is faster than rgba(). -->
    <div class="pswp__bg"></div>

    <!-- Slides wrapper with overflow:hidden. -->
    <div class="pswp__scroll-wrap">

        <!-- Container that holds slides.
            PhotoSwipe keeps only 3 of them in the DOM to save memory.
            Don't modify these 3 pswp__item elements, data is added later on. -->
        <div class="pswp__container">
            <div class="pswp__item"></div>
            <div class="pswp__item"></div>
            <div class="pswp__item"></div>
        </div>

        <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->
        <div class="pswp__ui pswp__ui--hidden">

            <div class="pswp__top-bar">

                <!--  Controls are self-explanatory. Order can be changed. -->

                <div class="pswp__counter"></div>

                <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>

                <button class="pswp__button pswp__button--share" title="Share"></button>

                <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>

                <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>

                <!-- Preloader demo https://codepen.io/dimsemenov/pen/yyBWoR -->
                <!-- element will get class pswp__preloader--active when preloader is running -->
                <div class="pswp__preloader">
                    <div class="pswp__preloader__icn">
                      <div class="pswp__preloader__cut">
                        <div class="pswp__preloader__donut"></div>
                      </div>
                    </div>
                </div>
            </div>

            <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
                <div class="pswp__share-tooltip"></div>
            </div>

            <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
            </button>

            <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
            </button>

            <div class="pswp__caption">
                <div class="pswp__caption__center"></div>
            </div>

        </div>

    </div>

</div>
`

function getGalleryItems (imageset) {
  let container = imageset.parentNode

  while (container.parentNode && !container.classList.contains('js-gallery')) {
    container = container.parentNode
  }

  const imagesets = container.querySelectorAll('.js-gallery-link')
  const items = []

  for (let i = 0, l = imagesets.length; i < l; i++) {
    const imagesetItem = imagesets[i]
    const img = imagesetItem.querySelector('img')

    if (img === null) {
      continue
    }

    if (img.hasAttribute('srcset')) {
      const srcset = parseSrcset(img.getAttribute('srcset'))

      let largest = null

      for (let i = 0, l = srcset.length; i < l; i++) {
        if (!largest || srcset[i].w > largest.w) {
          largest = srcset[i]
        }
      }

      items.push({
        src: largest.url,
        w: largest.w,
        h: largest.w * img.offsetHeight / img.offsetWidth,
        msrc: img.currentSrc,
        sourceImage: img,
        sourceImageset: imagesetItem
      })
    }
  }

  return items
}

let currentGalleryItems = null

const PHOTOSWIPE_OPTIONS = {
  index: 0,
  history: false,
  shareEl: false,
  bgOpacity: 0.95,

  getThumbBoundsFn (index) {
    const thumbnail = currentGalleryItems[index].sourceImage
    const pos = thumbnail.getBoundingClientRect()

    return {
      x: pos.left,
      y: pos.top + window.pageYOffset,
      w: pos.width
    }
  }

}

/* eslint-disable-next-line camelcase */
function openGallery (link, PhotoSwipe, PhotoSwipeUI_Default) {
  const options = Object.assign({}, PHOTOSWIPE_OPTIONS)
  const items = getGalleryItems(link, parseSrcset)

  for (let i = 0, l = items.length; i < l; i++) {
    if (items[i].sourceImageset === link) {
      options.index = i
      break
    }
  }

  currentGalleryItems = items

  const gallery = new PhotoSwipe($('.pswp'), PhotoSwipeUI_Default, items, options)

  gallery.init()
}

async function init (galleries) {
  const { default: Masonry } = await import('masonry-layout')
  const { default: PhotoSwipe } = await import('photoswipe')
  /* eslint-disable-next-line camelcase */
  const { default: PhotoSwipeUI_Default } = await import('photoswipe/dist/photoswipe-ui-default')

  for (const el of galleries) {
    /* eslint-disable-next-line no-new */
    new Masonry(el, {
      itemSelector: '.c-gallery__item',
      columnWidth: '.c-gallery__sizer',
      percentPosition: true,
      gutter: 0,
      transitionDuration: 0,
      isResizeBound: true
    })

    for (const link of $$('.js-gallery-link', el)) {
      link.addEventListener('click', function (e) {
        openGallery(this, PhotoSwipe, PhotoSwipeUI_Default)
        e.preventDefault()
      })
    }

    el.classList.add('is-init')
  }
}

const galleries = $$('.js-gallery')

if (galleries.length > 0) {
  document.body.insertAdjacentHTML('beforeend', photoswipeHtml)
  init(galleries)
}
